import { useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { NetInfoStateType } from '@react-native-community/netinfo';

import { setConnectionIsCorrect } from 'store/connection/actions';
import { selectConnectionType } from 'store/user/selectors';

import useConnectionIndicator from 'components/ConnectionIndicatorAlert/hooks';

type Params = {
    playerVisible: boolean;
};

function useConnectionTypeChange({ playerVisible }: Params) {
    const { connectionType } = useConnectionIndicator();
    const prevConnectionType = useRef(connectionType);
    const dispatch = useDispatch();

    const selectedConnectionType = useSelector(selectConnectionType);

    useEffect(() => {
        if (playerVisible) {
            if (
                prevConnectionType.current &&
                connectionType === NetInfoStateType.cellular &&
                selectedConnectionType === NetInfoStateType.wifi
            ) {
                // connectionTypeChanged();
                dispatch(setConnectionIsCorrect(true));
            }
            if (
                (connectionType === NetInfoStateType.wifi &&
                    selectedConnectionType === NetInfoStateType.wifi) ||
                (connectionType === NetInfoStateType.cellular &&
                    selectedConnectionType === NetInfoStateType.cellular)
            ) {
                // connectionTypeBack();
                dispatch(setConnectionIsCorrect(false));
            }

            prevConnectionType.current = connectionType;
        }
    }, [
        connectionType,
        prevConnectionType,
        selectedConnectionType,
        playerVisible,
    ]);
}

export default useConnectionTypeChange;
